import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { paths } from '../../../../../../common/constants/pathVariables.js';
import { SubscriptionCategory } from '../../../../../../common/enums.js';
import { t } from '../../../../../../common/i18n/index.js';
import {
  employeeSubscriptionsSubtitleMsg,
  myDevicesAndSubscriptionsMsg,
  mySubscriptionsMsg,
  omaElisaForEmployeeMsg,
} from '../../../../../../common/i18n/shared.js';
import { EoeSubscriptionsLayout } from '../../../../../../components/EoeSubscriptions/EoeSubscriptionsLayout.js';
import { EoeVoiceAndBroadbandSubscriptions } from '../../../../../../components/EoeSubscriptions/EoeVoiceAndBroadbandSubscriptions.js';
import { getEmployeeSubscriptions } from '../../../../../../selfservice/actions/index.js';
import { useAuth } from '../../../../AuthProvider.js';

export const EoeSubsPath = () => {
  const dispatch = useDispatch();
  const { authenticatedUser } = useAuth();

  useEffect(() => {
    if (authenticatedUser?.businessId) {
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.VOICE));
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.BROADBAND));
    }
  }, [dispatch, authenticatedUser?.businessId]);

  return (
    <EoeSubscriptionsLayout
      breadCrumbs={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.YRZJ(myDevicesAndSubscriptionsMsg), path: paths.EMPLOYEE_SUBSCRIPTIONS },
        { name: t.K31E(mySubscriptionsMsg) },
      ]}
      title={t.K31E(mySubscriptionsMsg)}
      subtitle={t.UO3T(employeeSubscriptionsSubtitleMsg)}
    >
      <EoeVoiceAndBroadbandSubscriptions />
    </EoeSubscriptionsLayout>
  );
};
